// Custom SVG path for Flickity, drawn on a 100 100 viewbox.
export const flickityArrowShape = 'M62.7 98a3.27 3.27 0 002.3-1 3.39 3.39 0 000-4.74L23.34 50 65 7.72A3.39 3.39 0 0065 3a3.27 3.27 0 00-4.67 0L14 50l46.36 47a3.3 3.3 0 002.34 1z';
